import { Button, Message, useToaster } from 'rsuite';
import React from 'react';

import * as partnersApi from '../../api/partners';
import { FormModal } from '../../common/FormModal';
import { useFormErrors } from '../../common/useFormErrors';
import PartnerModalContent from './PartnerModalContent';

type Props = {
  open: boolean;
  setOpen: (newValue: boolean) => void;
  callback: () => void;
};

export default function CreatePartnerModal({ open, setOpen, callback }: Props) {
  const toaster = useToaster();
  const { errorSummary, setApiError, clearErrors } = useFormErrors({
    fallbackMessage: 'Не вдалося створити партнера. Спробуйте пізніше',
    resetOn: [open],
  });
  const [modalPartnerName, setModalPartnerName] = React.useState<string>('');
  const [modalPartnerNameEn, setModalPartnerNameEn] =
    React.useState<string>('');
  const [modalPartnerNameDe, setModalPartnerNameDe] =
    React.useState<string>('');
  const [modalPartnerDescription, setModalPartnerDescription] =
    React.useState<string>('');
  const [modalPartnerDescriptionEn, setModalPartnerDescriptionEn] =
    React.useState<string>('');
  const [modalPartnerDescriptionDe, setModalPartnerDescriptionDe] =
    React.useState<string>('');
  const [modalPartnerDescriptionLong, setModalPartnerDescriptionLong] =
    React.useState<string>('');
  const [modalPartnerDescriptionLongEn, setModalPartnerDescriptionLongEn] =
    React.useState<string>('');
  const [modalPartnerDescriptionLongDe, setModalPartnerDescriptionLongDe] =
    React.useState<string>('');
  const [modalPartnerAnnotation, setModalPartnerAnnotation] =
    React.useState<string>('');
  const [modalPartnerAnnotationEn, setModalPartnerAnnotationEn] =
    React.useState<string>('');
  const [modalPartnerAnnotationDe, setModalPartnerAnnotationDe] =
    React.useState<string>('');
  const [modalPartnerLink, setModalPartnerLink] = React.useState<string>('');

  return (
    <FormModal
      open={open}
      onClose={() => setOpen(false)}
      title="Створити партнера"
      errorSummary={errorSummary}
      footer={
        <>
          <Button
            onClick={async () => {
              clearErrors();
              try {
                await partnersApi.create(
                  modalPartnerName,
                  modalPartnerNameEn,
                  modalPartnerNameDe,
                  modalPartnerDescription,
                  modalPartnerDescriptionEn,
                  modalPartnerDescriptionDe,
                  modalPartnerDescriptionLong,
                  modalPartnerDescriptionLongEn,
                  modalPartnerDescriptionLongDe,
                  modalPartnerAnnotation,
                  modalPartnerAnnotationEn,
                  modalPartnerAnnotationDe,
                  modalPartnerLink
                );
                setOpen(false);
                setModalPartnerName('');
                setModalPartnerNameEn('');
                setModalPartnerNameDe('');
                setModalPartnerDescription('');
                setModalPartnerDescriptionEn('');
                setModalPartnerDescriptionDe('');
                setModalPartnerDescriptionLong('');
                setModalPartnerDescriptionLongEn('');
                setModalPartnerDescriptionLongDe('');
                setModalPartnerAnnotation('');
                setModalPartnerAnnotationEn('');
                setModalPartnerAnnotationDe('');
                setModalPartnerLink('');
                callback();
              } catch (err: any) {
                console.error(err);
                const errorMessage = setApiError(err)[0];
                toaster.push(
                  <Message type="error" showIcon closable>
                    {errorMessage}
                  </Message>,
                  {
                    placement: 'topEnd',
                    duration: 1500,
                  }
                );
              }
            }}
            appearance="primary"
          >
            Створити
          </Button>
          <Button onClick={() => setOpen(false)} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <PartnerModalContent
        modalPartnerName={modalPartnerName}
        modalPartnerNameEn={modalPartnerNameEn}
        modalPartnerNameDe={modalPartnerNameDe}
        modalPartnerDescription={modalPartnerDescription}
        modalPartnerDescriptionEn={modalPartnerDescriptionEn}
        modalPartnerDescriptionDe={modalPartnerDescriptionDe}
        modalPartnerDescriptionLong={modalPartnerDescriptionLong}
        modalPartnerDescriptionLongEn={modalPartnerDescriptionLongEn}
        modalPartnerDescriptionLongDe={modalPartnerDescriptionLongDe}
        modalPartnerAnnotation={modalPartnerAnnotation}
        modalPartnerAnnotationEn={modalPartnerAnnotationEn}
        modalPartnerAnnotationDe={modalPartnerAnnotationDe}
        modalPartnerLink={modalPartnerLink}
        setModalPartnerName={setModalPartnerName}
        setModalPartnerNameEn={setModalPartnerNameEn}
        setModalPartnerNameDe={setModalPartnerNameDe}
        setModalPartnerDescription={setModalPartnerDescription}
        setModalPartnerDescriptionEn={setModalPartnerDescriptionEn}
        setModalPartnerDescriptionDe={setModalPartnerDescriptionDe}
        setModalPartnerDescriptionLong={setModalPartnerDescriptionLong}
        setModalPartnerDescriptionLongEn={setModalPartnerDescriptionLongEn}
        setModalPartnerDescriptionLongDe={setModalPartnerDescriptionLongDe}
        setModalPartnerAnnotation={setModalPartnerAnnotation}
        setModalPartnerAnnotationEn={setModalPartnerAnnotationEn}
        setModalPartnerAnnotationDe={setModalPartnerAnnotationDe}
        setModalPartnerLink={setModalPartnerLink}
      />
    </FormModal>
  );
}
